//178
import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import {
  PaintColorMaterial,
  WoodTopMaterial,
  WoodTopPaintColorMaterial,
} from '../../utils/materials';

export function Lottie_dining_bench(props) {
  const { nodes, materials, scene } = useGLTF('models/Lottie Dining Bench.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-lottie_dining_bench-paint_color',
    aoIntensity,
  );
  useSetMaterialFinish(
    WoodTopPaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-lottie_dining_bench-wood_top',
    aoIntensity,
  );
  useSetMaterialFinish(
    WoodTopMaterial,
    currentMaterialFinish.woodTopFinish,
    defaultFinish.woodTopFinish,
    'ao-lottie_dining_bench-wood_top',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      {currentMaterialFinish?.woodTopFinish?.name === 'Painted' ? (
        <mesh
          castShadow
          geometry={nodes.Wood_Top.geometry}
          material={WoodTopPaintColorMaterial}
        />
      ) : (
        <mesh
          castShadow
          geometry={nodes.Wood_Top.geometry}
          material={WoodTopMaterial}
        />
      )}
      <Shadow model={'Lottie Dining Bench'} />
    </group>
  );
}
